import { render, staticRenderFns } from "./CRUDTarifas.vue?vue&type=template&id=5511d3e4&"
import script from "./CRUDTarifas.vue?vue&type=script&lang=js&"
export * from "./CRUDTarifas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports